var map = {
	"./arrow-down.svg": "c874",
	"./benefits/benefit-1-active.svg": "f1ab",
	"./benefits/benefit-1.svg": "5da9",
	"./benefits/benefit-2-active.svg": "cf93",
	"./benefits/benefit-2.svg": "ba06",
	"./benefits/benefit-3-active.svg": "5af4",
	"./benefits/benefit-3.svg": "3c3b",
	"./benefits/benefit-4-active.svg": "eddf",
	"./benefits/benefit-4.svg": "2298",
	"./benefits/benefit-5-active.svg": "b70f",
	"./benefits/benefit-5.svg": "dfe7",
	"./benefits/benefit-6-active.svg": "8424",
	"./benefits/benefit-6.svg": "28ba",
	"./burger.svg": "ada2",
	"./close.png": "c821",
	"./footer-logo.svg": "744f",
	"./logo-dark.svg": "2e13",
	"./logo-light.svg": "8f04",
	"./logo.svg": "5b1c",
	"./modal-close.png": "398c",
	"./modal-success.svg": "3b82",
	"./plans-discount.svg": "3cb9",
	"./platform/dots.svg": "f5d3",
	"./platform/lines/line-analytics-md.svg": "7b43",
	"./platform/lines/line-analytics-sm.svg": "32f8",
	"./platform/lines/line-analytics.svg": "4cfb",
	"./platform/lines/line-channel.svg": "7112",
	"./platform/lines/line-engine-md.svg": "3799",
	"./platform/lines/line-engine-sm.svg": "1cc0",
	"./platform/lines/line-engine.svg": "cb46",
	"./platform/lines/line-event.svg": "b1ec",
	"./platform/lines/line-external.svg": "97f1",
	"./platform/lines/line-meta.svg": "8113",
	"./platform/lines/line-personalized-md.svg": "b91b",
	"./platform/lines/line-personalized.svg": "483b",
	"./platform/lines/line-transactional-md.svg": "e553",
	"./platform/lines/line-transactional-sm.svg": "8d1a",
	"./platform/lines/line-transactional.svg": "52cf",
	"./platform/lines/line-ux-md.svg": "1f96",
	"./platform/lines/line-ux-sm.svg": "44f2",
	"./platform/lines/line-ux.svg": "d697",
	"./platform/mobile2.svg": "004f",
	"./platform/platform-analytics-32.svg": "6cb2",
	"./platform/platform-analytics.png": "0f75",
	"./platform/platform-analytics.svg": "98b3",
	"./platform/platform-channel-32.svg": "9dc7",
	"./platform/platform-channel.png": "49f5",
	"./platform/platform-channel.svg": "3180",
	"./platform/platform-engine-32.svg": "1e08",
	"./platform/platform-engine.png": "f6d2",
	"./platform/platform-engine.svg": "6280",
	"./platform/platform-event-32.svg": "7132",
	"./platform/platform-event.png": "92c5",
	"./platform/platform-event.svg": "451c",
	"./platform/platform-external-32.svg": "8748",
	"./platform/platform-external.png": "d787",
	"./platform/platform-external.svg": "0937",
	"./platform/platform-logo-mobile.png": "a732",
	"./platform/platform-logo.png": "bfdb",
	"./platform/platform-meta-32.svg": "fdda",
	"./platform/platform-meta.png": "8834",
	"./platform/platform-meta.svg": "6c61",
	"./platform/platform-personal-32.svg": "e974",
	"./platform/platform-personal.svg": "8a70",
	"./platform/platform-personalized.png": "f7ad",
	"./platform/platform-personalized.svg": "5c1f",
	"./platform/platform-transactional-32.svg": "8dfd",
	"./platform/platform-transactional.png": "64b3",
	"./platform/platform-transactional.svg": "9b3a",
	"./platform/platform-ux-32.svg": "d4a3",
	"./platform/platform-ux.png": "17ae",
	"./platform/platform-ux.svg": "f047",
	"./slider-left.svg": "81cb",
	"./slider-right.svg": "c80f",
	"./star.svg": "cc90",
	"./tick.svg": "812c",
	"./value/value-1.svg": "67ff",
	"./value/value-2.svg": "f1e8",
	"./value/value-3.svg": "f2f8",
	"./value/value-4.svg": "398b",
	"./value/value-5.svg": "2e34",
	"./value/value-6.svg": "5995"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";